module.exports = __webpack_public_path__ + "media/icons/no_check@3x-76a23003.svg";